import styled from 'styled-components';
export const Spinner = styled.div`
  width: 5rem;
  height: 5rem;
  animation: spin 0.5s linear infinite;
`;
